import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-box-wrap" }
const _hoisted_2 = { class: "step-box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "1. Kennzeichen Finden", -1)
const _hoisted_4 = { class: "step-arrow" }
const _hoisted_5 = { class: "step-box" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "2. Daten eingegbene", -1)
const _hoisted_7 = { class: "step-arrow" }
const _hoisted_8 = { class: "step-box" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "3. Reservieren und bestellen", -1)

import Step1Animation from '@/assets/animations/home-animation-1.json';
import Step2Animation from '@/assets/animations/animation-step-2.json';
import Step3Animation from '@/assets/animations/home-animation-2.json';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Vue3Lottie, {
        animationData: _unref(Step1Animation),
        height: 150,
        width: 200
      }, null, 8, ["animationData"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'arrow-right'] })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_Vue3Lottie, {
        animationData: _unref(Step2Animation),
        height: 150,
        width: 200
      }, null, 8, ["animationData"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'arrow-right'] })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_Vue3Lottie, {
        animationData: _unref(Step3Animation),
        height: 150,
        width: 200
      }, null, 8, ["animationData"])
    ])
  ]))
}
}

})